import md5 from 'js-md5'
export default{
    install (Vue, options) {
        Vue.prototype.$getSign = function (paramAry) {
            var param = ksort(this, paramAry);
            var paramsTmp = [];
            for(var i in param){
                paramsTmp.push(i+"="+param[i]);
            }
            // $.each(param, function(i,n){
            //     paramsTmp.push(i+"="+n);
            // })
            return md5(paramsTmp.join("&")+'hylanda');
        }
        function ksort(vm, inputArr, sort_flags) {
            var tmp_arr = {},
           keys = [],
           sorter, i, k, that = vm,
           strictForIn = false,
           populateArr = {};
        
         switch (sort_flags) {
           case 'SORT_STRING':
             // compare items as strings
             sorter = function (a, b) {
               return that.strnatcmp(a, b);
             };
             break;
           case 'SORT_LOCALE_STRING':
             // compare items as strings, original by the current locale (set with  i18n_loc_set_default() as of PHP6)
             var loc = vm.i18n_loc_get_default();
             sorter = vm.php_js.i18nLocales[loc].sorting;
             break;
           case 'SORT_NUMERIC':
             // compare items numerically
             sorter = function (a, b) {
               return ((a + 0) - (b + 0));
             };
             break;
           // case 'SORT_REGULAR': // compare items normally (don't change types)
           default:
             sorter = function (a, b) {
               var aFloat = parseFloat(a),
                 bFloat = parseFloat(b),
                 aNumeric = aFloat + '' === a,
                 bNumeric = bFloat + '' === b;
               if (aNumeric && bNumeric) {
                 return aFloat > bFloat ? 1 : aFloat < bFloat ? -1 : 0;
               } else if (aNumeric && !bNumeric) {
                 return 1;
               } else if (!aNumeric && bNumeric) {
                 return -1;
               }
               return a > b ? 1 : a < b ? -1 : 0;
             };
             break;
         }
        
         // Make a list of key names
         for (k in inputArr) {
           if (inputArr.hasOwnProperty(k)) {
             keys.push(k);
           }
         }
         keys.sort(sorter);
        
         // BEGIN REDUNDANT
         vm.php_js = vm.php_js || {};
         vm.php_js.ini = vm.php_js.ini || {};
         // END REDUNDANT
         strictForIn = vm.php_js.ini['phpjs.strictForIn'] && vm.php_js.ini['phpjs.strictForIn'].local_value && vm.php_js
           .ini['phpjs.strictForIn'].local_value !== 'off';
         populateArr = strictForIn ? inputArr : populateArr;
        
         // Rebuild array with sorted key names
         for (i = 0; i < keys.length; i++) {
           k = keys[i];
           tmp_arr[k] = inputArr[k];
           if (strictForIn) {
             delete inputArr[k];
           }
         }
         for (i in tmp_arr) {
           if (tmp_arr.hasOwnProperty(i)) {
             populateArr[i] = tmp_arr[i];
           }
         }
        
         return strictForIn || populateArr;
       }
    }
}